import Vue from 'vue'
import Vuex from 'vuex'
/* 日志 start*/
import createLogger from 'vuex/dist/logger'
/* 日志 end */

import VuexPersistence from 'vuex-persist'
import userInfo from './modules/user'
import systemInfo from './modules/systemInfo'
import menuInfo from './modules/menuInfo'
import systemSupport from './modules/systemSupport'
import lawyerInfo from './modules/lawyerInfo'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
})

const store = new Vuex.Store({
  state: {
    token: '',
    authModel: 'server',
    checkData: {
      SHAREDJSESSIONID: null,
      expried: null,
    },
    expiredTime: 30, // token的有效期 默认30分钟
    publicKey: '',
    todoCount: 0,
    inboxCount: 0,
    announcementCount: 0,
    todoList: [],
    inboxList: [],
    announcementList: [],
  },
  getters: {
    token: state => state.token,
    authModel: state => state.authModel || 'server',
    expiredTime: state => state.expiredTime || 30,
    checkData: state => state.checkData,
    publicKey: state => state.publicKey,
    todoCount: state => state.todoCount,
    inboxCount: state => state.inboxCount,
    announcementCount: state => state.announcementCount,
    todoList: state => state.todoList,
    inboxList: state => state.inboxList,
    announcementList: state => state.announcementList
  },
  mutations: {
    // 设置token
    setToken (state, data) {
      state.token = data // 存vuex
    },
    setCheckData (state, data) {
      state.checkData = data // 存vuex
      state.token = data?.SHAREDJSESSIONID
    },
    setExpiredTime (state, data) {
      state.expiredTime = data // 存vuex
    },
    setPublicKey (state, data) {
      state.publicKey = data // 存vuex
    },
    SET_TODOCOUNT (state, payload) {
      state.todoCount = payload
    },
    SET_INBOXCOUNT (state, payload) {
      state.inboxCount = payload
    },
    SET_ANNOUNCEMENTCOUNT (state, payload) {
      state.announcementCount = payload
    },
    SET_TODOLIST (state, payload) {
      state.todoList = payload
    },
    SET_ANNOUNCEMENTLIST (state, payload) {
      state.announcementList = payload
    },
    SET_INBOXLIST (state, payload) {
      state.inboxList = payload
    },
    setAuthModel (state, payload) {
      state.authModel = payload
    },
  },
  actions: {
    async createToken (context, data) {
      let checkData = {}
      checkData.SHAREDJSESSIONID = data
      checkData.expried = new Date().getTime() + (this.getters.expiredTime * 60 * 1000 - 1000)
      context.commit("setCheckData", checkData)
    },
    async refreshToken (context) {
      let checkData = this.getters.checkData || {}
      if (checkData.SHAREDJSESSIONID) {
        checkData.expried = new Date().getTime() + (this.getters.expiredTime * 60 * 1000 - 1000)
        context.commit("setCheckData", checkData)
      }
    },
    // 退出操作
    async resetAll (context) {
      context.commit("setCheckData", null)
      window.localStorage.clear()
      window.sessionStorage.clear()
    },
    updateExpiredTime (context, data) {
      context.commit("setExpiredTime", data)
    },
    updatePublicKey (context, data) {
      context.commit("setPublicKey", data)
    },
    async updateAuthModel (context, data) {
      context.commit("setAuthModel", data)
    },
  },
  // 注册模块
  modules: { userInfo: userInfo, systemInfo: systemInfo, menuInfo: menuInfo, systemSupport: systemSupport, lawyerInfo: lawyerInfo },
  plugins: process.env.NODE_ENV !== 'production' ? [createLogger(), vuexLocal.plugin] : [vuexLocal.plugin],
})

export default store